import React,{useEffect} from 'react'
import { useAuth } from '../../context/AuthContext'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import {  Dashboard, DoorSliding, Dvr, FollowTheSigns, Home,  Label,  ListAlt,  ManageAccounts, MoreVert, Newspaper, Settings,TransferWithinAStation, Tv, WorkOutlined} from '@mui/icons-material';
import useBusinessInfo from '../../hooks/useBusinessInfo';

import moment from 'moment';

function AdminHeader() {

    const {authUser } = useAuth();
    const businessInfo = useBusinessInfo();

    const navigate = useNavigate();
    useEffect(()=>{
        if(businessInfo?.accountStatus === false){
          navigate("/admin/suspend-page");
        }
    },[businessInfo])

    return (
        <>
        {businessInfo?.pendingDays < 15 &&
            <div className="">
                <div className='text-danger text-center'> Your Account will suspend on { moment(businessInfo.validTill).format("ll")} please recharge asap</div>
            </div>
        }
        <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top shadow mb-3">
            <div className="container-fluid">
                <Link className="me-5" to="/">
                    {/* <img src='/images/gtoken-logo.jpg' style={{height:40}} /> */}
                    <img src='/globalinc.png' style={{height:40}} />
                </Link> {/* navbar-brand  */}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="collapsibleNavbar">
                    { authUser.role <= 2 && 
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{fontSize:"18px"}}>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/"> <Home/> Home</NavLink></li>
                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle" to="/report" role="button" data-bs-toggle="dropdown"><Dashboard/>Dashboard</NavLink>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/admin/checkin/dashboard"><Dashboard/>Checkin Dashboard</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/admin/slot/dashboard"><Dashboard/>Slot Dashboard</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/remark/dashboard"><Dashboard/>Remark Dashboard</NavLink></li>
                            </ul>
                        </li>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/queue/dashboard"> <TransferWithinAStation /> Queue</NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/kiosk/dashboard" > <Dvr/> Kiosk</NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/display/dashboard"><Tv/> Display</NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/counter/dashboard"> <FollowTheSigns/> Counter</NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/gatepass/dashboard"> <DoorSliding/> Gatepass</NavLink></li>
                        { authUser.role == 1 && <li className="nav-item"><NavLink className="nav-link text-center" to="/cms/ads"> <Newspaper/> CMS</NavLink></li> }
                        {/* <li className="nav-item"><NavLink className="nav-link text-center" to="/report/token-report"> <ListAlt/>Report</NavLink></li> */}
                        
                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle" to="/report" role="button" data-bs-toggle="dropdown"><ListAlt/>Report</NavLink>
                            <ul className="dropdown-menu">
                                { authUser.role == 1 &&
                                    <>
                                        <li><NavLink className="dropdown-item" to="/report/token-report-admin">Token Report</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/report/appointment-report-admin">Slot Token Report</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/report/remark-detailed-report-admin">Remark Report</NavLink></li>
                                    </>
                                }
                                { authUser.role == 2 &&
                                    <>
                                        <li><NavLink className="dropdown-item" to="/report/token-report">Token Report</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/report/appointment-report">Slot Token Report</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/report/remark-detailed-report">Remark Report</NavLink></li>
                                    </>
                                }
                                <li><NavLink className="dropdown-item" to="/report/remark/search">Remark Search</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/report/feedback-report">Feedback Report</NavLink></li>
                            </ul>
                        </li>
                        
                    </ul>
                    }
                    {/* Just for Alignment  */}
                    { authUser.role > 2 &&
                        <div className=" me-auto "></div>
                    } 

                        <ul className="navbar-nav">
                            { authUser.role == 1 && 
                            <li className="nav-item dropdown">
                                <a className="nav-link" href="!#" id="adminControllDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> <MoreVert/> </a>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="adminControllDropdown">
                                    <li><NavLink className="dropdown-item" to="/master/list"><Label /> Status Master</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/business/details"><WorkOutlined/> Business Details</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/user/list"><ManageAccounts/> Manage User Accounts</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/user/role"><Settings/> Manage User Role</NavLink></li>
                                </ul>
                            </li>
                            }



                            <li className="nav-item dropdown">
                                <a className="btn btn-danger" style={{borderRadius:"50px"}} href="!#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> 
                                    {authUser.firstName.charAt(0).toUpperCase()}
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                                    {/*<li><a className="dropdown-item" href="/auth/change-password">Change Password</a></li> */}
                                    <li><hr className="dropdown-divider"/></li>
                                    <li><NavLink className="dropdown-item" to="/auth/logout">Logout</NavLink></li>
                                </ul>
                            </li>
                        </ul>
                </div>
            </div>
        </nav>
        </>
    )
}

export default AdminHeader